import { makeObservable, observable, action } from 'mobx';
import RecordRequests from 'Utils/Requests/RecordRequests';
import AppStore from "Stores/AppStore";
import { ShowAlert } from "Utils/CommonFunctions";
import SettingsRequests from 'Utils/Requests/SettingsRequests';
import FiltersStore from 'Stores/ProtocolRecords/FiltersStore';

class ProtocolRecordsStore {
    records;
    recordsLoading;
    selectedRecordsIds;
    blinkItems;
    /** @type {ProtocolState} */
    state;
    pageToSet;
    printEnvironmentRequested;
    showTechInfo;

    constructor() {
        makeObservable(this, {
            records: observable,
            recordsLoading: observable,
            selectedRecordsIds: observable,
            blinkItems: observable,
            state: observable,
            printEnvironmentRequested: observable,
            showTechInfo: observable
        });

        this.printEnvironmentRequested = false;
        this.showTechInfo = false;
        this.ClearStore();
    }

    ClearStore = action(() => {
        this.records = [];
        this.blinkItems = [];
        this.recordsLoading = false;
        this.filterButtonClicked = false;
        this.selectedRecordsIds = [];
        this.state = {
            inProcess: false,
            firstAvailableRecord: 0,
            clearProgress: 0,
            hasArchive: false
        };
        this.pageToSet = 1;
        this.showTechInfo = false;
    });

    GetData = action((pageToSet, showSelected) => {
        if (pageToSet)
            this.pageToSet = pageToSet;
        if (!this.pageToSet)
            this.pageToSet = 1;

        this.recordsLoading = true;
        let elementsPerPage = this.tableStore.paginationInfo.elementsPerPage;
        let start = (this.pageToSet - 1) * elementsPerPage;

        let filters = {
            ... FiltersStore.filters,
            start: start,
            length: elementsPerPage,
            selectedRecordsIds: showSelected ? this.selectedRecordsIds : []
        };

        RecordRequests.GetData(filters).then(action((values) => {
            if (!values.error) {
                if (values.currentPageOfData != null)
                    this.pageToSet = values.currentPageOfData;

                if (!this.tableStore.HandlePagination(this.SetPageData, values.recordsFiltered, this.pageToSet, page => this.GetData(page, showSelected)))
                    return;

                this.records = values.data;

                this.tableStore.data = this.records;

                if (values.firstSelectedRecordId != null)
                    this.blinkItems = [values.firstSelectedRecordId];

                this.showTechInfo = values.showTechInfo;
            }
            else {
                ShowAlert('error', "Ошибка поиска");
            }

            this.recordsLoading = false;
        }));
    });

    SetPageData(pageToSet) {
        window.history.pushState(null, "Протоколирование", `${window.SmrLocation}/protocolRecords?page=${pageToSet}`);

        AppStore.SetLastPageInfo({
            pageTitle: 'protocolRecords',
            params: {
                page: `${pageToSet}`
            }
        });
    }

    SetTableStore(store) {
        this.tableStore = store;
    }

    PrintSelectedLogs = action(() => {
        RecordRequests.PrintSelectedLogs(this.selectedRecordsIds);

        this.selectedRecordsIds = [];
        this.SelectCurrentPageOfTable(false);
    });

    PrintFilteredLogs() {
        RecordRequests.PrintFilteredLogs(FiltersStore.filters);
    }

    ClearProtocolRecords() {
        return RecordRequests.ClearProtocol()
            .then(action(result => {
                if (result.error) {
                    ShowAlert('error', result.error.errorText);
                }
                else {
                    this.GetData();
                }
            }));
    }

    DownloadLastProtocolArchive() {
        RecordRequests.GetLastProtocolArchive();
    }

    SetProtocolState = action((state) => {
        this.state = state;
    });

    SelectItemInTable = action((id, isSelect) => {
        this.SelectItemsInTable([id], isSelect);
    });

    SelectCurrentPageOfTable = action((isSelect) => {
        this.SelectItemsInTable(this.records.map(it => it.id), isSelect);
    });

    SelectItemsInTable = action((ids, isSelect) => {
        this.selectedRecordsIds = isSelect
            ? this.selectedRecordsIds.concat(ids.filter(id => this.selectedRecordsIds.some(itSelectedRecordId => itSelectedRecordId == id) == false))
            : this.selectedRecordsIds.filter(itSelectedRecordId => ids.some(id => id == itSelectedRecordId) == false);
    });

    SaveSettingCbProtocolShowBoxRecords(settingValue) {
        SettingsRequests.SaveSettingCbProtocolShowBoxRecords(settingValue);
    }

    PrintEnvironment = action(() => {
        if (this.printEnvironmentRequested)
            return;

        this.printEnvironmentRequested = true;

        RecordRequests.PrintEnvironment()
            .finally(action(() => this.printEnvironmentRequested = false));
    });
}

export default new ProtocolRecordsStore();